import { selectUomVolume } from '@/entities/user/selectors/selectUomVolume'
import { selectUomWeight } from '@/entities/user/selectors/selectUomWeight'
import { UtilisationPie } from '@/shared/components/UtilisationPie/UtilisationPie'
import { useAppSelector } from '@/shared/store'

export type TreeLabelUtilisationPieProps = {
  type: 'weight' | 'volume' | 'workingHours'
  maxValue: number
  capacity: number
}

export const TreeLabelUtilisationPie: React.FC<TreeLabelUtilisationPieProps> = ({ type, maxValue, capacity }) => {
  const uomWeight = useAppSelector(state => selectUomWeight(state)) || ''
  const uomVolume = useAppSelector(state => selectUomVolume(state)) || ''
  

  const getShiftUtilisationData = (val: number, cap: number) => {
    const allocatedPercentage = Math.round((val / cap * 100) * 100) / 100
    const availablePercentage = Math.round(((cap - val) / cap * 100) * 100) / 100

    let overCapacityPercentage = 0
    let isOverCapacity = false

    // Unit of measure
    let unitOfMeasure = 'mins'
    let overCapacityTooltipString = ''

    if (type === 'weight') {
      unitOfMeasure = uomWeight
    } else if (type === 'volume') {
      unitOfMeasure = uomVolume
    }


    // Construct tooltip string for allocated and available
    const prefix = type.charAt(0).toUpperCase() + type.slice(1)
    const availableTooltipString = `${prefix} - Available: ${cap - val} ${unitOfMeasure} (${availablePercentage}%)`
    const allocatedTooltipString = `${prefix} - Allocated: ${val} ${unitOfMeasure} (${allocatedPercentage}%)`

    if (cap - val < 0) {
      overCapacityPercentage = -availablePercentage
      overCapacityTooltipString = `${prefix} - Over Allocated: ${-Math.round(val - cap * 100) / 100} ${unitOfMeasure} (${overCapacityPercentage}%)`
      isOverCapacity = true
    }

    return {
      isOverCapacity,
      allocatedPercentage,
      availablePercentage,
      availableTooltipString,
      allocatedTooltipString,
      overCapacityTooltipString,
    }
  }
  const { isOverCapacity, allocatedPercentage, availablePercentage, availableTooltipString, allocatedTooltipString, overCapacityTooltipString } = getShiftUtilisationData(maxValue, capacity)

  return capacity !== 0 && (
    <UtilisationPie
      greenPercentage={Number(availablePercentage)}
      bluePercentage={Number(allocatedPercentage)}
      redTooltip={overCapacityTooltipString}
      greenTooltip={availableTooltipString}
      blueTooltip={allocatedTooltipString}
      showAsRed={isOverCapacity}
      size={21}
    />)
}